/* ==========================================================
   Jé Vue · The House of Visions — theme behaviour (Shopify)
   Built from the approved Phase 1 preview. Each page is a real
   Shopify page; this script adds the overlays, the real bag,
   the gallery, form checks and the House opening sequence.
   Every part checks that its markup is on the page first.
   ========================================================== */
(function(){
'use strict';
const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
const html = document.documentElement;
const mqRM = matchMedia('(prefers-reduced-motion: reduce)');
const mqMobile = matchMedia('(max-width: 900px)');
const JV = window.__JV || {};
const A = p => (window.__JV_ASSETS && window.__JV_ASSETS[p]) || p;
const ROUTE = html.dataset.route || '';
const LIVE = !!JV.liveForms;
let open = null;   // the open overlay: { name, el, trigger }
const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);

/* ==========================================================
   Scene placement (House hero): the room, bag and shadow share
   one coordinate system, so the bag always stays on the plinth.
   ========================================================== */
const RATIO = 1448/1086, BAG_X = 0.558;
function placeScene(){
  const scene = $('[data-scene]'); if (!scene) return;
  const box = scene.parentElement, bw = box.clientWidth, bh = box.clientHeight;
  if (!bw || !bh) return;
  let w, h, left, top;
  if (mqMobile.matches){
    h = bh * 1.04; w = h * RATIO;
    if (w < bw * 1.2){ w = bw * 1.2; h = w / RATIO; }
    left = bw * 0.5 - w * 0.60;
    top = (bh - h) * 0.62;
  } else {
    w = Math.max(bw, bh * RATIO); h = w / RATIO;
    const bx = BAG_X + Math.min(0.09, Math.max(0, (1440 - bw) / 1440 * 0.22));
    left = bw * bx - w * BAG_X;
    top = (bh - h) * 0.42;
  }
  left = Math.min(0, Math.max(bw - w, left));
  top  = Math.min(0, Math.max(bh - h, top));
  Object.assign(scene.style, { width:w+'px', height:h+'px', left:left+'px', top:top+'px' });
  scene.classList.add('is-placed');
}
let rq = 0;
const onResize = () => { cancelAnimationFrame(rq); rq = requestAnimationFrame(placeScene); };
addEventListener('resize', onResize, { passive:true });
addEventListener('orientationchange', onResize);
(mqMobile.addEventListener ? mqMobile.addEventListener('change', onResize) : mqMobile.addListener(onResize));
placeScene();

/* Missing-asset handling: a restrained placeholder rather than a broken image. */
$$('img').forEach(img => {
  if (img.closest('#jv-entrance')) return;
  const mark = () => {
    if (img.classList.contains('scene__room')) { img.classList.add('is-missing'); return; }
    if (img.classList.contains('house-backdrop__img')) { img.style.visibility = 'hidden'; return; }
    (img.closest('figure, button, a, .bag__thumb') || img.parentElement).classList.add('asset-missing');
  };
  if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) mark();
  else img.addEventListener('error', mark, { once:true });
});

/* Skip link */
on($('[data-skip]'), 'click', e => {
  e.preventDefault();
  const m = $('#MainContent'); m.setAttribute('tabindex', '-1'); m.focus();
  m.addEventListener('blur', () => m.removeAttribute('tabindex'), { once:true });
});

/* In-page links (tables of contents, the sign-up) scroll smoothly */
document.addEventListener('click', e => {
  const a = e.target.closest('a[href^="#"]:not([href="#"])');
  if (!a || a.hasAttribute('data-skip')) return;
  const t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
  e.preventDefault();
  t.scrollIntoView({ behavior: mqRM.matches ? 'auto' : 'smooth', block: a.hasAttribute('data-focus-signup') ? 'center' : 'start' });
  const f = a.hasAttribute('data-focus-signup') ? $('#signup-email') : t;
  if (f){ if (!f.matches('input')) f.setAttribute('tabindex', '-1'); setTimeout(() => { try { f.focus({ preventScroll:true }); } catch(_){} }, mqRM.matches ? 0 : 450); }
});

/* Header state: solid near-black once the page scrolls (always solid away from the House hero) */
const hdr = $('#hdr');
function onScroll(){ hdr && hdr.classList.toggle('is-scrolled', scrollY > 24 || ROUTE !== 'house'); }
addEventListener('scroll', onScroll, { passive:true });
onScroll();

/* Reveal on scroll */
(function(){
  const items = $$('.reveal:not(.is-in)');
  if (!('IntersectionObserver' in window) || mqRM.matches){ items.forEach(el => el.classList.add('is-in')); return; }
  const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin:'0px 0px -8% 0px', threshold:.12 });
  items.forEach(el => io.observe(el));
})();

/* ==========================================================
   Overlays: search, bag, menu, lightbox, owner
   ========================================================== */
const scrim = $('[data-scrim]');
const PANELS = { search:'#panel-search', bag:'#panel-bag', menu:'#panel-menu', lightbox:'#panel-lightbox', owner:'#panel-owner' };
function focusables(el){
  return $$('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', el)
    .filter(n => n.offsetParent !== null || n === document.activeElement);
}
function openPanel(name, trigger){
  const handoff = open && open.name === 'menu' && name === 'search' ? open.trigger : null;
  if (open) closePanel(false);
  const el = $(PANELS[name]); if (!el) return false;
  el.hidden = false; if (scrim) scrim.hidden = name === 'lightbox' || name === 'menu';
  document.body.classList.add('is-locked');
  $$('.skip, .house-backdrop, .hdr, #MainContent, .ftr').forEach(n => n.setAttribute('inert', ''));
  open = { name, el, trigger: handoff || trigger || document.activeElement };
  if (trigger && trigger.hasAttribute && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
  if (name === 'search'){ const i = $('#searchInput'); i.value = ''; runSearch(''); setTimeout(() => i.focus(), 30); }
  else if (name === 'bag'){ refreshBag(); const c = el.querySelector('[data-close]'); c && setTimeout(() => c.focus(), 30); }
  else { const f = el.querySelector('[data-autofocus]') || focusables(el)[0]; f && setTimeout(() => f.focus(), 30); }
  return true;
}
function closePanel(restore = true){
  if (!open) return;
  const { el, trigger } = open;
  el.hidden = true; if (scrim) scrim.hidden = true;
  document.body.classList.remove('is-locked');
  $$('[inert]').forEach(n => { if (!n.closest('#jv-entrance') && !html.classList.contains('jv-entrance')) n.removeAttribute('inert'); });
  if (trigger && trigger.hasAttribute && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
  open = null;
  if (restore && trigger && document.contains(trigger)) try { trigger.focus({ preventScroll:true }); } catch(e){}
}

document.addEventListener('click', e => {
  const o = e.target.closest('[data-open]');
  if (o){
    // The bag on the /cart page itself simply stays on the page.
    if (o.dataset.open === 'bag' && ROUTE === 'cart') return;
    e.preventDefault(); openPanel(o.dataset.open, o); return;
  }
  if (e.target.closest('[data-close]')){ closePanel(); return; }
  if (scrim && e.target === scrim){ closePanel(); return; }
});
document.addEventListener('keydown', e => {
  if (!open || html.classList.contains('jv-entrance')) return;
  if (e.key === 'Escape'){ e.preventDefault(); closePanel(); return; }
  if (open.name === 'lightbox' && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')){ e.preventDefault(); stepLightbox(e.key === 'ArrowRight' ? 1 : -1); return; }
  if (e.key === 'Tab'){
    const f = focusables(open.el); if (!f.length) return;
    const first = f[0], last = f[f.length-1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }
});
const closeMenuOnWide = () => { if (!mqMobile.matches && open && open.name === 'menu') closePanel(false); };
(mqMobile.addEventListener ? mqMobile.addEventListener('change', closeMenuOnWide) : mqMobile.addListener(closeMenuOnWide));

/* ---------- Search: the House's own pages, then Shopify search for everything else ---------- */
const INDEX = [
  { k:'Current Vision', t:'Shoppé', s:'Vision Form. A structure for a higher perspective.', href:'/pages/shoppe', img:A('assets/vision-bag-large.webp'),
    words:'shoppe shoppé handbag bag vision form exhibit product structure higher perspective acquire diagonal textured inset handle' },
  { k:'Current Vision', t:'The work of the House, now', s:'Vision Forms: the wing the House is presenting.', href:'/pages/current-vision', img:A('assets/vision-bag-large.webp'),
    words:'current vision forms vf wing' },
  { k:'The House', t:'The House of Visions', s:'Jé Vue, from J’ai vu: I saw. Every object begins with a vision.', href:(JV.root || '/') + '#about', img:A('assets/house-room.jpg'),
    words:'house home about je vue jé vue jai vu saw visions philosophy designed to be seen archive museum' },
  { k:'Future Visions', t:'Not yet seen', s:'The Bison · Fun in the Sun', href:'/pages/future-visions', img:A('assets/jevue-eye.jpg'),
    words:'future visions bison fun in the sun next coming soon forming' },
  { k:'Correspondence', t:'Write to the House', s:'Inquiries, client care, press, collaborations and business.', href:'/pages/correspondence', img:A('assets/jevue-eye.jpg'),
    words:'correspondence contact letter write email message press collaboration wholesale business inquiry' },
  { k:'Client Care', t:'Client Care', s:'Orders, preorders, shipping, returns and care.', href:'/pages/client-care', img:'',
    words:'client care help faq questions order preorder support' },
  { k:'Client Care', t:'Shipping & Delivery', s:'Processing, delivery, tracking and international shipping.', href:'/pages/shipping', img:'',
    words:'shipping delivery tracking processing international' },
  { k:'Client Care', t:'Returns & Exchanges', s:'Return window, eligibility, exchanges and refunds.', href:'/pages/returns', img:'',
    words:'returns exchanges refund' },
  { k:'Legal', t:'Privacy Policy', s:'How information is collected and used.', href:'/pages/privacy', img:'', words:'privacy policy data' },
  { k:'Legal', t:'Terms of Service', s:'The terms of using the House.', href:'/pages/terms', img:'', words:'terms service legal' },
  { k:'The House', t:'Accessibility', s:'Movement, the entrance, and navigating the House.', href:'/pages/accessibility', img:'', words:'accessibility reduce motion keyboard screen reader' }
];
const norm = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
function hl(text, q){
  if (!q) return esc(text);
  const n = norm(text), i = n.indexOf(q);
  if (i < 0) return esc(text);
  return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
}
const searchUrl = q => (JV.search || '/search') + '?q=' + encodeURIComponent(q);
function runSearch(raw){
  const list = $('[data-search-results]'), count = $('#searchCount'); if (!list) return;
  const q = norm(raw.trim());
  const terms = q.split(/\s+/).filter(Boolean);
  const hits = !terms.length ? INDEX : INDEX.filter(it => { const hay = norm(it.k + ' ' + it.t + ' ' + it.s + ' ' + it.words); return terms.every(t => hay.includes(t)); });
  const all = terms.length ? '<li class="search__all"><a href="' + searchUrl(raw.trim()) + '"><span class="thumb thumb--mark" aria-hidden="true"></span><span><span class="k">Everything</span><span class="t">Search all of the House for “' + esc(raw.trim()) + '”</span></span></a></li>' : '';
  if (!hits.length){
    count.textContent = 'No pages match';
    list.innerHTML = '<li class="search__empty">Nothing in the House matches “' + esc(raw.trim()) + '”. Try one of these:<br>' +
      ['Shoppé', 'Client Care', 'Shipping', 'Returns'].map(s => '<button type="button" data-suggest="' + esc(s) + '">' + esc(s) + '</button>').join('') + '</li>' + all;
    return;
  }
  count.textContent = terms.length ? hits.length + (hits.length === 1 ? ' result' : ' results') : 'In the House';
  list.innerHTML = hits.map(it => '<li><a href="' + esc(it.href) + '">' + (it.img ? '<img class="thumb" src="' + esc(it.img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="thumb thumb--mark" aria-hidden="true"></span>') +
    '<span><span class="k">' + esc(it.k) + '</span><span class="t">' + hl(it.t, terms[0]) + '</span><span class="s">' + hl(it.s, terms[0]) + '</span></span></a></li>').join('') + all;
}
on($('#searchInput'), 'input', e => runSearch(e.target.value));
on($('[data-search-form]'), 'submit', e => {
  const v = $('#searchInput').value.trim();
  const a = $('[data-search-results] li:not(.search__all) a');
  e.preventDefault();
  location.href = a && v ? a.getAttribute('href') : (v ? searchUrl(v) : (JV.search || '/search'));
});
on($('[data-search-results]'), 'click', e => {
  const b = e.target.closest('[data-suggest]');
  if (b){ const i = $('#searchInput'); i.value = b.dataset.suggest; runSearch(i.value); i.focus(); return; }
  // Links to a section of the page already open (the House's About) just close the panel and scroll.
  const a = e.target.closest('a'); if (!a) return;
  const u = new URL(a.href, location.href);
  if (u.pathname === location.pathname && u.hash){ e.preventDefault(); closePanel(false); const t = document.getElementById(u.hash.slice(1)); t && t.scrollIntoView({ behavior: mqRM.matches ? 'auto' : 'smooth' }); }
});

/* ---------- Your Bag: the real Shopify cart ---------- */
const BAG_SVG = '<svg viewBox="0 0 24 28" aria-hidden="true"><path d="M8.2 9.2V6.8a3.8 3.8 0 0 1 7.6 0v2.4"/><path d="M5.4 9.2h13.2l1.9 16.3H3.5z"/></svg>';
const root = (JV.root || '/').replace(/\/?$/, '/');
function money(cents, cur){
  try { return new Intl.NumberFormat(JV.locale || undefined, { style:'currency', currency: cur || JV.currency || 'USD' }).format(cents / 100); }
  catch(e){ return (cents / 100).toFixed(2); }
}
function setCount(n){
  const c = $('[data-bag-count]'), btn = $('.hdr__bag'); if (!c || !btn) return;
  c.hidden = n === 0; c.textContent = String(n);
  btn.setAttribute('aria-label', n ? 'Your Bag, ' + n + (n === 1 ? ' item' : ' items') : 'Your Bag, empty');
}
function renderBag(cart){
  const box = $('[data-bag]'); if (!box) return;
  setCount(cart.item_count);
  if (!cart.item_count){
    box.innerHTML = '<div class="bag__empty">' + BAG_SVG + '<h3>Your bag is empty.</h3><p>The Current Vision awaits on its plinth.</p><a class="btn-line" href="/pages/current-vision">View the Current Vision</a></div>';
    return;
  }
  box.innerHTML = cart.items.map(it =>
    '<div class="bag__item" data-key="' + esc(it.key) + '"><a class="bag__thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" width="120" height="146">' : '') + '</a><div>' +
      '<p class="bag__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p><p class="bag__meta">' +
      (it.variant_title && !/^default title$/i.test(it.variant_title) ? esc(it.variant_title) + '<br>' : '') + money(it.final_line_price, cart.currency) + '</p>' +
      '<div class="bag__row"><div class="qty" role="group" aria-label="Quantity of ' + esc(it.product_title) + '">' +
        '<button type="button" data-qty="-1" aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
        '<output aria-label="Quantity">' + it.quantity + '</output>' +
        '<button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
        '<button class="bag__remove" type="button" data-remove>Remove</button></div>' +
    '</div></div>').join('') +
    '<div class="bag__sum"><span>Subtotal</span><span class="bag__sum-val">' + money(cart.total_price, cart.currency) + '</span></div>' +
    '<div class="bag__foot"><a class="btn" href="' + root + 'checkout">Continue to secure checkout</a>' +
    '<p>Shipping and taxes are calculated at checkout. <a href="' + esc(JV.cart || '/cart') + '">View the full bag</a></p></div>';
}
function bagError(){
  const box = $('[data-bag]'); if (!box) return;
  box.innerHTML = '<div class="bag__empty">' + BAG_SVG + '<h3>Your bag could not be loaded.</h3><p>Please try again in a moment.</p><a class="btn-line" href="' + esc(JV.cart || '/cart') + '">Open the bag page</a></div>';
}
function refreshBag(){
  return fetch(root + 'cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
    .then(r => r.ok ? r.json() : Promise.reject(r.status)).then(c => { renderBag(c); return c; }).catch(bagError);
}
function changeLine(key, quantity){
  return fetch(root + 'cart/change.js', { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ id:key, quantity }) })
    .then(r => r.ok ? r.json() : Promise.reject(r.status)).then(c => { renderBag(c); return c; }).catch(bagError);
}
on($('[data-bag]'), 'click', e => {
  const row = e.target.closest('[data-key]'); if (!row) return;
  const key = row.dataset.key, q = e.target.closest('[data-qty]');
  if (q){
    const cur = parseInt(row.querySelector('output').textContent, 10) || 1;
    const dir = q.dataset.qty;
    changeLine(key, Math.max(1, cur + parseInt(dir, 10))).then(() => { const b = $('[data-key="' + CSS.escape(key) + '"] [data-qty="' + dir + '"]'); (b && !b.disabled ? b : $('[data-bag] .bag__remove') || $('#panel-bag [data-close]')).focus(); });
    return;
  }
  if (e.target.closest('[data-remove]')) changeLine(key, 0).then(() => { const f = $('[data-bag] .bag__remove') || $('[data-bag] a') || $('#panel-bag [data-close]'); f && f.focus(); });
});

/* Add to Bag on a Vision Exhibit (only present when a real, available product with a price exists) */
$$('form[data-add-form]').forEach(f => f.addEventListener('submit', e => {
  e.preventDefault();
  const btn = f.querySelector('[type="submit"]'), s = $('[data-add-status]');
  btn.disabled = true;
  fetch(root + 'cart/add.js', { method:'POST', credentials:'same-origin', headers:{ 'Accept':'application/json' }, body: new FormData(f) })
    .then(r => r.json().then(j => r.ok ? j : Promise.reject(j)))
    .then(item => { s && (s.innerHTML = esc(item.product_title) + ' was added to your bag. <button type="button" data-open="bag">View bag</button>'); return refreshBag(); })
    .catch(err => { s && (s.textContent = (err && (err.description || err.message)) || 'This could not be added to your bag. Please try again.'); })
    .finally(() => { btn.disabled = false; });
}));

/* ---------- Gallery & lightbox (Vision Exhibit) ---------- */
const thumbs = $$('[data-gallery-thumb]');
const main = $('[data-gallery-main]'), mainBtn = $('[data-gallery-open]');
const G = thumbs.map(b => ({ src:b.dataset.src, w:+b.dataset.w || 0, h:+b.dataset.h || 0, kind:b.dataset.kind || 'photo', caption:b.dataset.caption || '', alt:b.dataset.alt || '' }));
let gi = 0;
function showImage(i, instant){
  if (!G.length || !main) return;
  gi = (i + G.length) % G.length;
  const g = G[gi];
  thumbs.forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.galleryThumb === gi)));
  const apply = () => { main.src = g.src; if (g.w){ main.width = g.w; main.height = g.h; } main.alt = g.alt; mainBtn.dataset.kind = g.kind; main.classList.remove('is-swapping'); };
  if (instant || mqRM.matches) apply(); else { main.classList.add('is-swapping'); setTimeout(apply, 220); }
  mainBtn.setAttribute('aria-label', 'Enlarge image ' + (gi + 1) + ' of ' + G.length + (g.caption ? ': ' + g.caption.toLowerCase() : ''));
}
function fillLightbox(){
  const g = G[gi], img = $('[data-lb-img]'); if (!g || !img) return;
  img.src = g.src; if (g.w){ img.width = g.w; img.height = g.h; } img.alt = g.alt;
  $('[data-lb-cap]').textContent = (gi + 1) + ' / ' + G.length + (g.caption ? ' · ' + g.caption : '');
}
function stepLightbox(d){ showImage(gi + d, true); fillLightbox(); }
if (G.length && mainBtn){
  thumbs.forEach(b => b.addEventListener('click', () => showImage(+b.dataset.galleryThumb)));
  mainBtn.addEventListener('click', () => { fillLightbox(); openPanel('lightbox', mainBtn); });
  $$('[data-lb-step]').forEach(b => b.addEventListener('click', () => stepLightbox(+b.dataset.lbStep)));
  on($('#panel-lightbox'), 'click', e => { if (e.target.id === 'panel-lightbox') closePanel(); });
  (function(){ let x0 = null; const el = $('#panel-lightbox'); if (!el) return;
    el.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive:true });
    el.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) stepLightbox(dx < 0 ? 1 : -1); x0 = null; });
  })();
  if (G.length < 2) $$('.lb__nav').forEach(b => b.hidden = true);
  showImage(0, true);
}

/* ---------- Correspondence: checks in the browser; Shopify sends only when real forms are on ---------- */
const form = $('#letterForm'), preview = $('#letterPreview');
if (form && form.querySelector('[data-rule]')){
  form.noValidate = true;
  const RULES = {
    topic:   v => !!v || 'Please choose the nature of your letter.',
    name:    v => v.trim().length >= 2 || 'Please enter your name.',
    email:   v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) || (v.trim() ? 'Please enter a valid email address, such as name@example.com.' : 'Please enter your email address.'),
    subject: v => v.trim().length >= 2 || 'Please add a subject.',
    message: v => v.trim().length >= 10 || (v.trim() ? 'Please write a little more (at least 10 characters).' : 'Please write your message.')
  };
  const fields = $$('[data-rule]', form);
  const check = field => {
    const res = RULES[field.dataset.rule](field.value), err = $('#e-' + field.dataset.rule);
    if (res === true){ field.removeAttribute('aria-invalid'); err.textContent = ''; return true; }
    field.setAttribute('aria-invalid', 'true'); err.textContent = res; return false;
  };
  form.addEventListener('blur', e => { const f = e.target; if (f.dataset && f.dataset.rule && (f.value || f.hasAttribute('aria-invalid'))) check(f); }, true);
  form.addEventListener('input', e => { if (e.target.hasAttribute('aria-invalid')) check(e.target); });
  form.addEventListener('change', e => { if (e.target.hasAttribute('aria-invalid')) check(e.target); });
  form.addEventListener('submit', e => {
    const bad = fields.filter(f => !check(f));
    const sum = $('[data-form-summary]', form);
    if (bad.length){ e.preventDefault(); sum.textContent = bad.length === 1 ? 'One field needs attention.' : bad.length + ' fields need attention.'; bad[0].focus(); return; }
    sum.textContent = '';
    if (!LIVE){
      e.preventDefault();
      form.reset();                       // nothing is kept
      form.hidden = true; preview.hidden = false; preview.focus();
    }
  });
  on($('[data-form-reset]'), 'click', () => { preview.hidden = true; form.hidden = false; fields[0].focus(); });
}
const sent = $('#letterSent[data-posted]');
if (sent){ sent.scrollIntoView({ block:'center' }); try { sent.focus({ preventScroll:true }); } catch(e){} }

/* ---------- House correspondence sign-up (footer) ---------- */
const signup = $('#signup');
if (signup){
  signup.noValidate = true;
  signup.addEventListener('submit', e => {
    const i = $('#signup-email'), m = $('#signup-msg'), v = i.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){ e.preventDefault(); i.setAttribute('aria-invalid', 'true'); m.textContent = v ? 'Please enter a valid email address.' : 'Please enter your email address.'; m.classList.add('is-error'); i.focus(); return; }
    i.removeAttribute('aria-invalid'); m.classList.remove('is-error');
    if (!LIVE){ e.preventDefault(); i.value = ''; m.textContent = 'Sign-ups are not open yet, so your address was not saved.'; }
  });
  // After Shopify returns from a sign-up, bring the message into view.
  if (/[?&]customer_posted=true\b/.test(location.search) || location.hash === '#signup'){
    const m = $('#signup-msg'); if (m && m.textContent.trim()) setTimeout(() => signup.scrollIntoView({ block:'center' }), 60);
  }
}

/* ---------- Owner tools: only while previewing an unpublished theme or in the theme editor ---------- */
(function(){
  const role = window.Shopify && Shopify.theme && Shopify.theme.role;
  const owner = (window.Shopify && Shopify.designMode) || (role && role !== 'main');
  if (!owner){ const p = $('#panel-owner'); p && p.remove(); return; }
  $$('[data-owner-only]').forEach(b => b.hidden = false);
  on($('[data-replay]'), 'click', () => {
    try { document.cookie = 'jevue_entered=; path=/; max-age=0; SameSite=Lax'; } catch(e){}
    try { sessionStorage.removeItem('jevue_entered'); sessionStorage.removeItem(SEQ_KEY); sessionStorage.removeItem('jevue_threshold_seen'); } catch(e){}
    location.href = root;
  });
  on($('[data-toggle-provisional]'), 'change', e => html.classList.toggle('show-provisional', e.target.checked));
})();

/* ==========================================================
   Opening sequence (first arrival in the House each session)
   Arrival → eye → CURRENT VISION → VISION FORM: Shoppé →
   the bag → the statement → EXPLORE THE VISION → rest.
   Any scroll, click, tap or key settles it at once.
   ========================================================== */
const SEQ_KEY = 'jevue_house_seq';
const SEQ = { eye:1200, cv:2600, form:3400, name:3600, bag:4900, line:6300, cta:7300, done:8200 };
const EYE_FADE = 1000;
const eyeApi = window.JVHouseEye || { start: () => Promise.resolve(false), setActive(){} };
let seqTimers = [], seqState = 'done';
const seqPlayed = () => { try { return sessionStorage.getItem(SEQ_KEY) === '1'; } catch(e){ return false; } };
const seqMark = () => { try { sessionStorage.setItem(SEQ_KEY, '1'); } catch(e){} };
const stepOn = name => $$('[data-seq-step="' + name + '"]').forEach(el => el.classList.add('is-on'));
const SKIP_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
function onSeqScroll(){ if (scrollY > 30) seqSkip(); }
function seqListen(go){
  SKIP_EVENTS.forEach(ev => (go ? addEventListener : removeEventListener)(ev, seqSkip, { capture:true, passive:true }));
  (go ? addEventListener : removeEventListener)('scroll', onSeqScroll, { passive:true });
}
function seqBegin(){
  if (seqState !== 'pre') return;
  seqState = 'wait';
  seqListen(true);
  const room = $('#roomImg');
  const ready = !room || (room.complete && room.naturalWidth) ? Promise.resolve()
    : new Promise(r => { room.addEventListener('load', r, { once:true }); room.addEventListener('error', r, { once:true }); });
  Promise.race([ready.then(() => room && room.decode ? room.decode().catch(() => {}) : 0), new Promise(r => setTimeout(r, 2500))]).then(seqRun);
}
function seqRun(){
  if (seqState !== 'wait') return;
  seqState = 'run'; html.dataset.seq = 'run'; seqMark();
  const at = (ms, fn) => seqTimers.push(setTimeout(fn, ms));
  ['eye','cv','form','name','bag','line','cta'].forEach(k => at(SEQ[k], () => stepOn(k)));
  at(SEQ.eye + EYE_FADE, () => eyeApi.setActive(true));
  at(SEQ.done, seqFinish);
}
function seqSkip(){
  if (seqState !== 'run' && seqState !== 'wait') return;
  if (seqState === 'wait'){ seqMark(); html.dataset.seq = 'run'; }
  seqState = 'skip';
  seqTimers.forEach(clearTimeout); seqTimers = [];
  html.classList.add('seq-fast');
  ['eye','cv','form','name','bag','line','cta'].forEach(stepOn);
  eyeApi.setActive(true);
  seqTimers.push(setTimeout(seqFinish, 650));
}
function seqFinish(){
  seqTimers.forEach(clearTimeout); seqTimers = [];
  seqListen(false);
  seqState = 'done'; html.dataset.seq = 'done'; html.classList.remove('seq-fast');
}
function seqInit(){
  window.__jvSeqReady = true;
  if (ROUTE !== 'house'){ html.dataset.seq = 'done'; return; }
  eyeApi.start();   // the eye loads quietly from the start
  const play = !seqPlayed() && !mqRM.matches && html.dataset.seq === 'pre';
  if (!play){ html.dataset.seq = 'done'; eyeApi.setActive(true); return; }
  seqState = 'pre';
  if (html.classList.contains('jv-entrance')){
    // Begin the moment the approved entrance has fully dissolved (it removes this class when done).
    const mo = new MutationObserver(() => { if (!html.classList.contains('jv-entrance')){ mo.disconnect(); seqBegin(); } });
    mo.observe(html, { attributes:true, attributeFilter:['class'] });
  } else {
    seqBegin();
  }
  // Arriving at the House's About section (#about) settles the sequence straight away.
  if (location.hash === '#about') seqSkip();
}
seqInit();
html.classList.remove('no-js');
})();
